import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import type { DateTimeValidationError, PickerChangeHandlerContext } from '@mui/x-date-pickers';
import { ByzColors } from 'src/theme/colors';

interface DateTimePickerProps extends Omit<React.ComponentProps<typeof DateTimePicker>, 'value' | 'onChange'> {
    value?: any;
    onChange?: (value: any, context?: PickerChangeHandlerContext<DateTimeValidationError>) => void;
    width?: string | number;
}

const defaultSlotProps = {
  textField: {
    size: "small" as const,
    fullWidth: true,
    InputLabelProps: {
      shrink: true,
    },
    sx: {
      "& .MuiInputLabel-root": {
        color: `${ByzColors.ByzBlue} !important`,
      },
      "&:hover .MuiInputLabel-root": {
        color: `${ByzColors.ByzBlue} !important`,
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: `${ByzColors.ByzBlue} !important`,
      },
      "& .MuiFormLabel-root": {
        color: `${ByzColors.ByzBlue} !important`,
      },
      "&:hover .MuiFormLabel-root": {
        color: `${ByzColors.ByzBlue} !important`,
      },
      "& .MuiFormLabel-root.Mui-focused": {
        color: `${ByzColors.ByzBlue} !important`,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: ByzColors.ByzBlue,
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: ByzColors.ByzBlue,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: ByzColors.ByzBlue,
      },
    },
  },
};

export const ByzMuiDateTimePicker = (props: DateTimePickerProps) => {
  const { width, ...restProps } = props;
  const userSlotProps = props.slotProps || {};
  const userTextField = (userSlotProps.textField as any) || {};
  const isDisabled = props.disabled || false;
  
  const disabledStyles = isDisabled ? {
    "& .MuiInputLabel-root.Mui-disabled": {
      color: `${ByzColors.ByzDisabledGray} !important`,
    },
    "& .MuiFormLabel-root.Mui-disabled": {
      color: `${ByzColors.ByzDisabledGray} !important`,
    },
    "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: `${ByzColors.ByzDisabledBorderGray} !important`,
    },
    "&:hover .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: `${ByzColors.ByzDisabledBorderGray} !important`,
    },
  } : {};

  const widthStyles = width ? { width } : {};
  
  const mergedSlotProps = {
    ...defaultSlotProps,
    ...userSlotProps,
    textField: {
      ...defaultSlotProps.textField,
      ...userTextField,
      InputLabelProps: {
        ...defaultSlotProps.textField.InputLabelProps,
        ...(userTextField.InputLabelProps || {}),
        disabled: isDisabled,
      },
      sx: {
        ...defaultSlotProps.textField.sx,
        ...disabledStyles,
        ...widthStyles,
        ...(userTextField.sx || {}),
      },
    },
  };

  return (
    <DateTimePicker
      {...restProps}
      slotProps={mergedSlotProps}
    />
  );
}